// extracted by mini-css-extract-plugin
export default {"welcomeText":"signup-page-module_welcomeText-vnc_l","welcomeTextContainer":"signup-page-module_welcomeTextContainer-FUx_u","error":"signup-page-module_error-iHYBs"};